// If there's an accept button
if ( ofh_accept_button = document.querySelector( '#cookie-banner-js-accept-button' ) ) {

	// Add an event listener for when the button is clicked
  ofh_accept_button.addEventListener( 'click', function () {

		// Check if we've got Matmo loaded
		// (not always the case due to privacy extensions and local testing)
		if ( typeof Matomo !== 'undefined' ) {

			// Set the accept cookie and trigger the accept goal on the primary tracker
			const tracker = Matomo.getTracker( matomoTrackerUrl, matomoPrimaryId );
			tracker.setCookieDomain( '*.' + window.location.hostname );
      tracker.setDocumentTitle( 'public site / ' + document.title );
      tracker.setDomains( [ '*.' + window.location.hostname ] );
			tracker.rememberConsentGiven( 8760 ); // Hours in a year
			tracker.trackPageView();
			tracker.trackGoal( matomoPrimaryAcceptGoal );

			// Set the accept cookie and trigger the accept goal on secondary tracker
			const tracker2 = Matomo.getTracker( matomoTrackerUrl, matomoSecondaryId );
			tracker2.setCookieDomain( '*.' + window.location.hostname );
      tracker2.setDocumentTitle( 'public site / ' + document.title );
      tracker2.setDomains( [ '*.' + window.location.hostname ] );
			tracker2.rememberConsentGiven( 8760 ); // Hours in a year
			tracker2.trackPageView();
			tracker2.trackGoal( matomoSecondaryAcceptGoal );

		}

		// Check if we've got Mixpanel loaded
		// (not always the case due to privacy extensions and local testing)
		if ( typeof mixpanel !== 'undefined' ) {

			// Opt in to tracking
			mixpanel.opt_in_tracking();

			// Track initial pageview
			mixpanel.track_pageview();

		}

		// If Matomo and Mixpanel aren't defined, we need to set a placeholder cookie anyway
		// so the cookie notice doesn't show up again
		if ( typeof Matomo === 'undefined' && typeof mixpanel === 'undefined' ) {

			// Write the placeholder accept cookie
			document.cookie =
				'mtm_consent=' + Date.now() + '; ' +
				'max-age=31536000; ' + // Seconds in a year
				'path=/; ' +
				'domain=' + window.location.hostname + '; ' +
				'SameSite=Strict; ' +
				'Secure';

		}

		// Add any UTM parameters to the UTM cookie
		ofh_write_utm_cookie();

		// Remove the cookie banner from the DOM tree
		document.querySelector( '#cookie-banner-js' ).remove();
  } );

}

// If there's a decline button
if ( ofh_decline_button = document.querySelector( '#cookie-banner-js-decline-button' ) ) {

	// Add an event listener for when the button is clicked
  ofh_decline_button.addEventListener( 'click', function () {

		// Check if we've got Matmo loaded
		// (not always the case due to privacy extensions and local testing)
		if ( typeof Matomo !== 'undefined' ) {

			// Track the decline on primary tracker
			const tracker = Matomo.getTracker( matomoTrackerUrl, matomoPrimaryId );
			tracker.trackGoal( matomoPrimaryDeclineGoal );

			// Track the decline on secondary tracker
			const tracker2 = Matomo.getTracker( matomoTrackerUrl, matomoSecondaryId );
			tracker2.trackGoal( matomoSecondaryDeclineGoal );

		}

		// Write the decline cookie
		document.cookie =
			'cookie_consent_refused=1; ' +
			'max-age=31536000; ' + // Seconds in a year
			'path=/; ' +
			'domain=' + window.location.hostname + '; ' +
			'SameSite=Strict; ' +
			'Secure';

		// Remove the cookie banner from the DOM tree
		document.querySelector( '#cookie-banner-js' ).remove();
  } );

}
